import React, { useState } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import ChatWindow from './components/ChatWindow';

const contacts = [
  { 
    id: 1, 
    name: 'Virat Kohli', 
    time: 'just now', 
    message: 'Sure, let me check that for you!', 
    profilePic: require('./assets/kohli.jpeg'), 
    status: 'Active now',
    messages: [
      { type: 'received', sender: 'Virat Kohli', text: 'Hi there! How can I help you today?' },
      { type: 'sent', sender: 'You', text: 'I had a question about the recent project updates.' },
    ]
  },
  { 
    id: 2, 
    name: 'Rohit Sharma', 
    time: '2h ago', 
    message: 'The meeting is scheduled for tomorrow...', 
    profilePic: require('./assets/rohit.jpeg'), 
    status: 'Last seen 2 hours ago',
    messages: [
      { type: 'received', sender: 'Rohit Sharma', text: 'Hey, do you have any updates on the report?' },
      { type: 'sent', sender: 'You', text: 'I will send it to you by the end of the day.' },
    ]
  },
  { 
    id: 3, 
    name: 'M.S. Dhoni', 
    time: 'just now', 
    message: 'Thanks for the update! 👍', 
    profilePic: require('./assets/dhoni.jpeg'), 
    status: 'Active now',
    messages: [
      { type: 'received', sender: 'M.S. Dhoni', text: 'Thanks for your help!' },
      { type: 'sent', sender: 'You', text: 'You are welcome! Let me know if you need anything else.' },
    ]
  },
];

function App() {
  const [currentChat, setCurrentChat] = useState(contacts[0]);
  const [newMessage, setNewMessage] = useState(''); // Manage new message input

  const handleChatClick = (contact) => {
    setCurrentChat(contact);
  };

  const handleSendMessage = () => {
    if (newMessage.trim() === '') return; // Don't send empty messages

    // Add the new message to the current chat's messages array
    const updatedChat = {
      ...currentChat,
      messages: [
        ...currentChat.messages,
        { type: 'sent', sender: 'You', text: newMessage },
      ],
    };

    setCurrentChat(updatedChat); // Update the current chat with the new message
    setNewMessage(''); // Clear the input field
  };

  return (
    <div className="chat-application">
      <Sidebar contacts={contacts} onChatClick={handleChatClick} />
      <ChatWindow 
        currentChat={currentChat} 
        newMessage={newMessage}
        setNewMessage={setNewMessage}
        handleSendMessage={handleSendMessage}
      />
    </div>
  );
}

export default App;
